<template>
    <div    class="flex flex-col w-1/3 items-center">
        <div>
            The user with the email "{{userEmail}}" is being created and should be setup within a minute or so. Please wait.
        </div>

        <div    class="my-2">
            <loading></loading>
        </div>

        <div    class="w-full mt-2">
            <!-- Return to Users Page link -->
            <button-blue-secondary      @click="returnToUsersPage">
                Return to Users Page
            </button-blue-secondary>
        </div>
    </div>

</template>

<script>
import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import UndecoratedLink from "@/components/EnterpriseDashboard/undecorated-link.vue";
import ButtonBlueSecondary from "../elements/buttons/ButtonBlueSecondary.vue";
import Loading from "../elements/loading.vue";

export default {
    name: "CreatingUser",
    mixins: [SonicuCoreMixin, iconNamesMixin],
    components: {Loading, ButtonBlueSecondary},
    emits: [],
    props: {
        userEmail: {
            type: String,
            required: true,
        },
    },
    data() {
        return {

        }
    },
    created() {

    },
    mounted() {
        this.checkIfUserIsCreated()
    },
    methods: {
        checkIfUserIsCreated() {
            axios.get(this.company.buildCompanyApiInternalRoute('check-user-created') + `/${this.userEmail}`, {
            }).then(response => {
                if (response.data.userCreated) {
                    this.returnToUsersPage();
                }
            }).catch(error => {
                console.log(error);
            }).then(() => {
                setTimeout(() => {
                    this.checkIfUserIsCreated();
                }, 2500);
            });
        },
        returnToUsersPage() {
            window.location.href = this.company.buildCompanyRoute('users');
        },
    },
    computed: {},
    watch: {},
}
</script>

<style scoped>

</style>